export default function initializeGallerySection() {
    new GallerySection();
}

class GallerySection {
    constructor() {
        this.init();
    }

    init() {
        const gallerySections = document.querySelectorAll('.gallery_section');
        gallerySections.forEach(section => {
            section.addEventListener('click', function () {
                const id = this.getAttribute('idgallery');
                const allGalleryLinks = document.querySelectorAll('.gallery__link');
                const allSiteGalleryBlocks = document.querySelectorAll('.site_gallery_block');
                const currentGalleryLinks = document.querySelectorAll(`.block-gallery-${id}`);
                const currentSiteGalleryBlocks = document.querySelectorAll('.site_gallery_block.section-show');

                gallerySections.forEach(section => {
                    section.classList.remove('btn-act');
                });

                this.classList.add('btn-act');

                const url = '';

                if (id == 'all') {
                    allGalleryLinks.forEach(link => {
                        link.classList.add('gallery-show');
                        link.setAttribute('data-fancybox', 'gallery-all');
                    });

                    allSiteGalleryBlocks.forEach(block => {
                        block.classList.add('section-show');
                    });

                    const url = this.getAttribute('baseurl');
                } else {
                    allGalleryLinks.forEach(link => {
                        link.classList.remove('gallery-show');
                    });

                    currentSiteGalleryBlocks.forEach(block => {
                        block.classList.remove('section-show');
                    });

                    currentGalleryLinks.forEach(link => {
                        link.classList.add('gallery-show');
                        link.setAttribute('data-fancybox', `gallery-${id}`);
                    });

                    const url = this.getAttribute('baseurl') + "?gallery=" + this.getAttribute('namegallery');
                }

                const title = this.getAttribute('basetitle');
                window.history.pushState("", title, url);
                document.title = title;
            });
        });
    }
}